import attorneyConstants from "../constants/attorneyConstants";
import attorneyService from "../services/attorneyService";
import alertActions from "./alertActions";
//import history from "../helpers/history";

const register = (dob, firstName, lastName, email, phoneNumber, barNumber) => {
  const request = (registerApplicationUser) => {
    return {
      type: attorneyConstants.ATTORNEY_REGISTER_REQUEST,
      registerApplicationUser,
    };
  };
  const success = (user) => {
    return { type: attorneyConstants.ATTORNEY_REGISTER_SUCCESS, user };
  };
  const failure = (error) => {
    //console.log(error);
    return { type: attorneyConstants.ATTORNEY_REGISTER_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(email));

    attorneyService
      .register(dob, firstName, lastName, email, phoneNumber, barNumber)
      .then(
        (user) => {
          dispatch(success(user));
          //history.push("/user");
          //console.log(user);
          dispatch(alertActions.success("Successfully registered attorney."));
        },
        (error) => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      );
  };
};

const userActions = {
  register,
};

export default userActions;
